export const SP_COVID19 = { name: 'sp-covid19', content: '\e93b' };
export const BLANK_CIRCLE = { name: 'blank-circle', content: '\e93d' };
export const PHISHING = { name: 'phishing', content: '\e939' };
export const CS_URLSCAN = { name: 'cs_urlscan', content: '\e93c' };
export const BLACKFISH = { name: 'blackfish', content: '\e941' };
export const CHROME_EXTENSION = { name: 'chrome-extension', content: '\e942' };
export const DEMISTO = { name: 'demisto', content: '\e943' };
export const IBM_RESILIENT = { name: 'ibm-resilient', content: '\e944' };
export const JIRA_CLOUD = { name: 'jira-cloud', content: '\e945' };
export const JIRA = { name: 'jira', content: '\e946' };
export const LOGRHYTHM = { name: 'logrhythm', content: '\e947' };
export const SERVICENOW = { name: 'servicenow', content: '\e949' };
export const SLACK = { name: 'slack', content: '\e94a' };
export const SPLUNK_ES = { name: 'splunk-es', content: '\e94b' };
export const SPLUNK = { name: 'splunk', content: '\e94c' };
export const IBM_QRADAR = { name: 'ibm-qradar', content: '\e940' };
export const SHODAN = { name: 'shodan', content: '\e93f' };
export const NETLABS_360_DGA = { name: 'netlabs-360-dga', content: '\e95d' };
export const CYJAX = { name: 'cyjax', content: '\e96c' };
export const BAMBENEK = { name: 'bambenek', content: '\e93e' };
export const I_JIRA = { name: 'i-jira', content: '\e93a' };
export const NCFTA = { name: 'ncfta', content: '\e938' };
export const AISAC = { name: 'aisac', content: '\e900' };
export const TRUSTAR = { name: 'trustar', content: '\e936' };
export const CS_CYBERSOURCE = { name: 'cs-cybersource', content: '\e903' };
export const CS_RISKIQ = { name: 'cs-riskiq', content: '\e904' };
export const CS_F_ISAC = { name: 'cs-F-ISAC', content: '\e905' };
export const CS_BF = { name: 'cs-BF', content: '\e902' };
export const CS_DS2 = { name: 'cs-DS2', content: '\e920' };
export const CS_ALIEN_VAULT = { name: 'cs-alien-vault', content: '\e901' };
export const CS_ALIEN_VAULT2 = { name: 'cs-alien-vault2', content: '\e906' };
export const CISCO = { name: 'cisco', content: '\e909' };
export const CS_CISCP_LOGO = { name: 'cs-ciscp-logo', content: '\e90a' };
export const CS_CROWDSTRIKE_FALCON2 = { name: 'cs-crowdstrike-falcon2', content: '\e90b' };
export const CS_CROWDSTRIKE1 = { name: 'cs-crowdstrike1', content: '\e90c' };
export const CS_DS = { name: 'cs-DS', content: '\e90d' };
export const CS_F_ISAC1 = { name: 'cs-F-ISAC1', content: '\e90e' };
export const CS_FARSIGHT_DNSDB = { name: 'cs-Farsight-DNSDB', content: '\e90f' };
export const CS_FB = { name: 'cs-FB', content: '\e910' };
export const CS_FLASHPOINT = { name: 'cs-flashpoint', content: '\e911' };
export const CS_FS_ISAC = { name: 'cs-FS-ISAC', content: '\e912' };
export const CS_HYBRID_ANALYSIS = { name: 'cs-hybrid-analysis', content: '\e913' };
export const CS_IBM = { name: 'cs-ibm', content: '\e914' };
export const CS_INSIGHT = { name: 'cs-insight', content: '\e915' };
export const CS_INTEL_471 = { name: 'cs-intel-471', content: '\e916' };
export const CS_INTEL471_ICON = { name: 'cs-intel471-icon', content: '\e917' };
export const CS_INTEL471_WORDS = { name: 'cs-intel471-words', content: '\e918' };
export const CS_ISIGHT_PARTNERS = { name: 'cs-isight-partners', content: '\e919' };
export const CS_JOE_SANDBOX = { name: 'cs-joe-sandbox', content: '\e91a' };
export const CS_MISP = { name: 'cs-MISP', content: '\e91b' };
export const CS_PACKETSTORM = { name: 'cs-packetstorm', content: '\e91c' };
export const CS_RECORDED_FUTURE_COLOR = { name: 'cs-recorded-future-color', content: '\e91d' };
export const CS_SPYCLOUD = { name: 'cs-spycloud', content: '\e91e' };
export const CS_VIRUS_TOTAL = { name: 'cs-virus-total', content: '\e91f' };
export const OS_UNIT_42 = { name: 'os-Unit-42', content: '\e907' };
export const OS_US_CERT = { name: 'os-US-CERT', content: '\e908' };
export const OS_PACKETSTORM1 = { name: 'os-packetstorm1', content: '\e921' };
export const OS_NIST = { name: 'os-NIST', content: '\e922' };
export const OS_MALWARE_BYTES = { name: 'os-malware-bytes', content: '\e923' };
export const OS_HYBRID_ANALAYSIS1 = { name: 'os-hybrid-analaysis1', content: '\e924' };
export const OS_HAILATAXII = { name: 'os-Hailataxii', content: '\e925' };
export const OS_H_ISAC = { name: 'os-H-ISAC', content: '\e926' };
export const OS_CERT_EU = { name: 'os-CERT-EU', content: '\e927' };
export const OS_AIS = { name: 'os-AIS', content: '\e928' };
export const OS_BROADANALISYS = { name: 'os-broadanalisys', content: '\e929' };
export const OS_ABUSE = { name: 'os-ABUSE', content: '\e92a' };
export const I_SPLUNK = { name: 'i-splunk', content: '\e92b' };
export const I_RESILENT = { name: 'i-resilent', content: '\e92c' };
export const I_IBM_Q_RADAR = { name: 'i-IBM-Q-Radar', content: '\e92d' };
export const I_DEMISTO = { name: 'i-Demisto', content: '\e92e' };
export const I_GOOGLE = { name: 'i-google', content: '\e92f' };
export const I_AWS = { name: 'i-AWS', content: '\e930' };
export const I_SLACK = { name: 'i-Slack', content: '\e931' };
export const I_SERVICENOW = { name: 'i-servicenow', content: '\e932' };
export const I_PHANTOM = { name: 'i-phantom', content: '\e933' };
export const I_LOG_RHYTHM = { name: 'i-log-rhythm', content: '\e934' };
export const I_JIRA2 = { name: 'i-jira2', content: '\e935' };
export const I_JIRA1 = { name: 'i-jira1', content: '\e937' };
